import { render } from "./ThePostItem.vue?vue&type=template&id=beca5824&scoped=true&ts=true"
import script from "./ThePostItem.vue?vue&type=script&lang=ts"
export * from "./ThePostItem.vue?vue&type=script&lang=ts"

import "./ThePostItem.vue?vue&type=style&index=0&id=beca5824&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beca5824"]])

export default __exports__